import React from 'react'
import InfoIcon from '@mui/icons-material/Info';
import RefreshIcon from '@mui/icons-material/Refresh';
function infosCard(props) { 
    return (     
      <div id='infosCard_cont'>
        <div id='infosCard'>
          <div id='infosCard_header'>
            <div className="header_app_title">
              <InfoIcon/><h1>LapMonitor Live</h1><h1>•</h1>
            </div>
          </div>
          <div id='infosCard_content'>
            {props.text}
          </div>
          <div id='infosCard_footer'>
            <button id='infosCard_footer_button' onClick={() => {location.reload()}}>Refresh<RefreshIcon/></button>
          </div>
        </div>       
      </div>  
    );
}

export default infosCard;